var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 9.16667V5.83333C6.66675 4.94928 7.01794 4.10143 7.64306 3.47631C8.26818 2.85119 9.11603 2.5 10.0001 2.5C10.8841 2.5 11.732 2.85119 12.3571 3.47631C12.9822 4.10143 13.3334 4.94928 13.3334 5.83333V9.16667M5.83341 9.16667H14.1667C15.0872 9.16667 15.8334 9.91286 15.8334 10.8333V15.8333C15.8334 16.7538 15.0872 17.5 14.1667 17.5H5.83341C4.91294 17.5 4.16675 16.7538 4.16675 15.8333V10.8333C4.16675 9.91286 4.91294 9.16667 5.83341 9.16667ZM10.8334 13.3333C10.8334 13.7936 10.4603 14.1667 10.0001 14.1667C9.53984 14.1667 9.16675 13.7936 9.16675 13.3333C9.16675 12.8731 9.53984 12.5 10.0001 12.5C10.4603 12.5 10.8334 12.8731 10.8334 13.3333Z",
    stroke: "#4D5A81",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedGroup);
export default __webpack_public_path__ + "static/media/closed-group.2647c6e2aa46b04cce51cb58b4d905e7.svg";
export { ForwardRef as ReactComponent };